<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <br/>
            <h2 class="text-center">วิธีการชำระเงิน</h2>
            <div class="row">
                <div class="col offset-sm-6 col-sm-6">
                    <div class="row form-group">
                        <div class="col col-6">
                            <label class="col-form-label text-right">ยอดที่ต้องชำระ</label>
                        </div>
                        <div class="col col-6">
                            <label class="col-form-label">
                                <strong>
                                    {{ form.amount | currency }}
                                </strong>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Cash -->
            <div class="form-group row">
                <div class="col pl-5">
                    <input class="form-check-input"
                           type="checkbox"
                           id="type-cash"
                           v-model="transactions.checkCash"/>
                    <label class="form-check-label" for="type-cash">
                        เงินสด
                    </label>
                </div>
                <template v-if="transactions.checkCash">
                    <div class="col">
                        <input type="number"
                               placeholder="จำนวนเงิน"
                               class="form-control"
                               v-model="transactions.cash.amount"
                               step="0.01"/>
                    </div>
                </template>
            </div>
            <hr>
            <!-- Cheque -->
            <div class="form-group row">
                <div class="col pl-5">
                    <input class="form-check-input"
                           type="checkbox"
                           id="type-cheque"
                           v-model="transactions.checkCheque"/>
                    <label class="form-check-label" for="type-cheque">
                        เช็ค
                    </label>
                </div>
            </div>
            <template v-if="transactions.checkCheque">
                <template v-for="(data,index) in transactions.cheque">
                    <div class="form-group row">
                        <div class="col" :for="`ref_no${index}`">
                            <input type="text"
                                   :id="`ref_no${index}`"
                                   placeholder="หมายเลขเช็ค"
                                   v-model="data.ref_no"
                                   class="form-control"/>
                        </div>
                        <div class="col" :for="`date${index}`">
                            <date-picker
                                :id="`date${index}`"
                                v-model="data.date"
                                class="w-100"
                                :format="changeFormat"
                                :lang="lang"
                                placeholder="ลงวันที่">
                            </date-picker>
                        </div>
                        <div class="col" :for="`bank_name${index}`">
                            <b-form-select v-model="data.cheque_bank_id"
                                           :options="optionBankType">
                            </b-form-select>
                        </div>
                        <div class="col">
                            <multiselect
                                v-model="data.bank_branch"
                                :options="optionBranch"
                                :customLabel="labelBranch"
                                :show-labels="false"
                                placeholder="สาขา"
                                track-by="id">
                            </multiselect>
                        </div>
                        <div class="col" :for="`amount${index}`">
                            <input type="number"
                                   :id="`amount${index}`"
                                   placeholder="จำนวนเงิน"
                                   v-model="data.amount"
                                   class="form-control"
                                   step="0.01"/>
                        </div>
                        <div class="col flex-grow-0">
                            <button class="btn btn-danger"
                                    v-if="transactions.cheque.length > 1"
                                    @click="removeCheque(index)">
                                <icon name="minus"></icon>
                            </button>
                        </div>
                    </div>
                </template>
                <div class="row">
                    <div class="col">
                        <button class="btn btn-primary" @click="addCheque">
                            <icon name="plus"></icon>
                            เพิ่มรายการ
                        </button>
                    </div>
                </div>
            </template>
            <hr>
            <!-- Transfer -->
            <div class="form-group row">
                <div class="col pl-5">
                    <input class="form-check-input"
                           type="checkbox"
                           id="type-transfer"
                           v-model="transactions.checkTransfer">
                    <label class="form-check-label" for="type-transfer">
                        เงินโอน
                    </label>
                </div>
            </div>
            <template v-if="transactions.checkTransfer">
                <template v-for="(data,index) in transactions.transfer ">
                    <div class="form-group row">
                        <div class="col" :for="`ref_no${index}`">
                            <multiselect
                                v-model="data.bank"
                                :options="optionBank"
                                :customLabel="customLabelBank"
                                :show-labels="false"
                                placeholder="เลขบัญชีธนาคาร"
                                track-by="id">
                            </multiselect>
                        </div>
                        <div class="col" :for="`date${index}`">
                            <date-picker
                                :id="`date${index}`"
                                class="w-100"
                                v-model="data.date"
                                :format="changeFormat"
                                :lang="lang"
                                placeholder="ลงวันที่">
                            </date-picker>
                        </div>
                        <div class="col" :for="`amount${index}`">
                            <input type="number"
                                   :id="`amount${index}`"
                                   placeholder="จำนวนเงิน"
                                   v-model="data.amount"
                                   class="form-control"
                                   step="0.01"/>
                        </div>
                        <div class="col flex-grow-0">
                            <button class="btn btn-danger"
                                    @click="removeTransfer(index)"
                                    v-if="transactions.transfer.length > 1">
                                <icon name="minus"></icon>
                            </button>
                        </div>
                    </div>
                </template>
                <div class="row">
                    <div class="col">
                        <button class="btn btn-primary" @click="addTransfer">
                            <icon name="plus"></icon>
                            เพิ่มรายการ
                        </button>
                    </div>
                </div>
            </template>
            <hr>
            <!-- Fee, offset, and pledge. -->
            <div class="row">
                <div class="col col-sm-6">
                    <div class="row form-group">
                        <div class="col col-5 text-right">
                            <label class="col-form-label">รับเงิน เกิน</label>
                        </div>
                        <div class="col col-6">
                            <input type="number"
                                   v-model="form.overpay"
                                   placeholder="รับเงิน เกิน"
                                   class="form-control"
                                   step="0.01">
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col col-5 text-right">
                            <label class="col-form-label">รับเงิน ขาด</label>
                        </div>
                        <div class="col col-6">
                            <input type="number"
                                   v-model="form.arrears"
                                   placeholder="รับเงิน ขาด"
                                   class="form-control"
                                   step="0.01">
                        </div>
                    </div>
                    <!--<div class="row form-group">-->
                    <!--<div class="col col-5 text-right">-->
                    <!--<label class="col-form-label text-right">ชำระด้วยเงินมัดจำ</label>-->
                    <!--</div>-->
                    <!--<div class="col col-6">-->
                    <!--<input type="number"-->
                    <!--placeholder="ชำระด้วยเงินมัดจำ"-->
                    <!--v-model="form.pledge_amount"-->
                    <!--class="form-control"-->
                    <!--step="0.01">-->
                    <!--</div>-->
                    <!--</div>-->
                </div>
                <div class="col col-sm-6">
                    <div class="row form-group">
                        <div class="col col-5 text-right">
                            <label class="col-form-label">Fee/ค่าธรรมเนียม</label>
                        </div>
                        <div class="col col-6">
                            <input type="number"
                                   placeholder="Fee/ค่าธรรมเนียม"
                                   v-model="form.fee_amount"
                                   class="form-control"
                                   step="0.01">
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <!-- Summary -->
            <div class="form-group row">
                <div class="col col-sm-6">
                    <label>
                        ยอดที่ต้องชำระ
                    </label>
                    <h2 class="form-control-plaintext">
                        {{ calculateTransaction > 0 ? (form.amount - calculateTransaction) : 0 | currency }}
                    </h2>
                </div>

                <div class="col col-sm-6 text-right">
                    <label>
                        รวมยอดเงินที่ชำระ
                    </label>
                    <h2 class="form-control-plaintext">
                        {{ calculateTransaction ? calculateTransaction : 0 | currency }}</h2>
                </div>
            </div>
            <div class="col text-center">
                <template v-if="form.payoff_status_id == 2">
                    <button @click="submitPayoff('print')"
                            type="button"
                            :disabled="isSubmit"
                            class="btn btn-success">
                        <icon name="save"></icon>
                        บันทึกและพิมพ์
                    </button>
                    &nbsp&nbsp
                </template>
                <template v-else>
                    <button @click="submitPayoff('save')"
                            type="button"
                            :disabled="isSubmit"
                            class="btn btn-success">
                        <icon name="save"></icon>
                        บันทึก
                    </button>
                    &nbsp&nbsp
                </template>
                <button @click="cancelPayoff"
                        type="button"
                        class="btn btn-outline-secondary">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>
            <br/>
        </div>
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
    </div>
</template>
<script>
import {mapState} from "vuex"
import Multiselect from "vue-multiselect"
import DatePicker from "vue2-datepicker"
import moment from "moment";
import Loading from "../../Utility/Loading";
import {domain} from "../../../util/Constants";

export default {
    name: "invoice-payoff-transaction-modal",
    props: {
        payoff_status_id: {default: null}
    },
    components: {
        Loading,
        Multiselect,
        DatePicker
    },
    data() {
        return {
            msg: '',
            status_loading: 1,
            isSubmit: false,
            optionBranch: [],
            items: [
                {
                    text: "รายการตัดชำระอื่นๆ",
                    to: {name: "invoice-payoff-other"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            taxOptions: [
                {
                    text: '0%',
                    value: 0
                },
                {
                    text: '7%',
                    value: 1
                },
            ],
            optionBankForCheque: [
                {text: 'กรุณาเลือกธนาคาร', value: ""},
                {text: 'OUB (ธนาคารยูโอบี)', value: 1},
                {text: 'KBank (ธนาคารสิกร)', value: 2},
                {text: 'TMB (ธนาคารทหารไทย)', value: 3},
            ],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    created() {
        this.$store.dispatch("Bank/getBankAll");
        this.$store.dispatch("Common/getBankType");
        this.$store.dispatch("Common/getBankBranch").then(res => {
            this.optionBranch = res;
        })
    },
    computed: {
        ...mapState({
            form: state => {
                return state.InvoicePayoff.form
            },
            transactions: state => {
                return state.InvoicePayoff.transactions
            },
            user: state => {
                return state.Auth.user;
            },
            optionBank: state => {
                return state.Bank.bank_all;
            },
            optionBankType: state => {
                return [
                    {
                        value: null,
                        text: "เลือกธนาคาร"
                    },
                    ...state.Common.bank_type.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ];
            }
        }),
        calculateTransaction() {
            let sum_amount = 0;
            let transactions = [];
            if (this.transactions.checkCash) {
                if (this.transactions.cash.amount) {
                    transactions.push(this.transactions.cash);
                }
            }
            if (this.transactions.checkCheque) {
                this.transactions.cheque.forEach(cheque => {
                    if (cheque.ref_no && cheque.cheque_bank_id && cheque.bank_branch) {
                        this.optionBankType.forEach(data => {
                            if (data.value == cheque.cheque_bank_id) {
                                cheque.bank_name = data.text
                            }

                        });
                        if (!cheque.date) {
                            const currentDate = moment().format("YYYY-MM-DD");
                            cheque.date = currentDate;
                        } else {
                            //console.log(cheque.date);
                            cheque.date = moment(cheque.date).format("YYYY-MM-DD")
                            let date_year = moment(cheque.date).format('YYYY'); //get year
                            if (date_year <= 2000) {
                                let current_year = moment().format("YYYY");
                                cheque.date = moment(cheque.date).format(+current_year + "-MM-DD")
                            }
                        }
                        if (!cheque.amount) {
                            cheque.amount = "";
                        }
                        transactions.push(cheque);
                    }
                });
            }
            if (this.transactions.checkTransfer) {
                this.transactions.transfer.forEach(transfer => {
                    if (transfer.bank) {
                        transfer.bank_id = transfer.bank.id;
                        if (!transfer.date) {
                            let currentDate = moment().format("YYYY-MM-DD");
                            transfer.date = currentDate;
                        } else {
                            transfer.date = moment(transfer.date).format("YYYY-MM-DD")
                            let date_year = moment(transfer.date).format('YYYY'); //get year
                            if (date_year <= 2000) {
                                let current_year = moment().format("YYYY");
                                transfer.date = moment(transfer.date).format(+current_year + "-MM-DD")
                            }
                        }
                        if (!transfer.amount) {
                            transfer.amount = "";
                        }
                        transactions.push(transfer);
                    }
                });
            }
            let price = 0;
            sum_amount = transactions.reduce((carry, detail) => {
                if (detail.amount) {
                    price = detail.amount
                } else {
                    price = 0;
                }
                return carry + parseFloat(price);
            }, 0);

            if (this.form.overpay) { //เงินเกิน
                sum_amount = sum_amount - parseFloat(this.form.overpay);
            }
            if (this.form.arrears) { //เงินขาด
                sum_amount = sum_amount + parseFloat(this.form.arrears);
            }
            if (this.form.fee_amount) { //ค่าธรรมเนียม
                sum_amount = sum_amount + parseFloat(this.form.fee_amount);
            }
            this.form.total = sum_amount;
            return sum_amount;
        }
    },
    methods: {
        labelBranch(option) {
            return `${option.branch_code} - ${option.name}`
        },
        customLabelBank(option) {
            return `${option.account_number} - ${option.name}`
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        submitPayoff(action) {
            this.form.transactions = [];
            if (this.transactions.checkCash) {
                if (this.transactions.cash.amount) {
                    this.form.transactions.push(this.transactions.cash);
                }
            }
            if (this.transactions.checkCheque) {
                this.transactions.cheque.forEach(cheque => {
                    if (cheque.ref_no && cheque.cheque_bank_id && cheque.bank_branch) {
                        if (!cheque.date) {
                            const currentDate = moment().format("YYYY-MM-DD");
                            cheque.date = currentDate;
                        } else {
                            cheque.date = moment(cheque.date).format("YYYY-MM-DD")
                        }
                        if (!cheque.amount) {
                            cheque.amount = "";
                        }
                        cheque.bank_branch_id = cheque.bank_branch.id;
                        this.form.transactions.push(cheque);
                    }
                });
            }
            if (this.transactions.checkTransfer) {
                this.transactions.transfer.forEach(transfer => {
                    if (transfer.bank) {
                        transfer.bank_id = transfer.bank.id;
                        if (!transfer.date) {
                            let currentDate = moment().format("YYYY-MM-DD");
                            transfer.date = currentDate;
                        } else {
                            transfer.date = moment(transfer.date).format("YYYY-MM-DD")
                        }
                        if (!transfer.amount) {
                            transfer.amount = 0;
                        }
                        this.form.transactions.push(transfer);
                    }
                });
            }

            //คำนวนยอดที่รับมา
            let pay = this.form.transactions.reduce((carry, detail) => {
                return carry + parseFloat(detail.amount);
            }, 0);
            // //console.log("pay",pay);
            // //console.log("amount",this.form.amount);
            //เชค รับเงินเกิน - รับเงินขาด
            if (this.form.overpay) { //เงินเกิน
                pay = pay - parseFloat(this.form.overpay);
            }
            if (this.form.arrears) { //เงินขาด
                pay = pay + parseFloat(this.form.arrears);
            }
            if (this.form.fee_amount) { //ค่าธรรมเนียม
                pay = pay + parseFloat(this.form.fee_amount);
            }
            if (this.form.amount < 1) {
                alert("กรุณากรอกจำนวนเงินที่ต้องการชำระ");
            } else if ((parseFloat(this.form.amount) - parseFloat(this.calculateTransaction)) !== 0) {
                alert("ยอดชำระไม่ถูกต้อง")
            } else if (!this.form.date) {
                alert("กรุณาใส่วันที่ที่ต้องการตัดชำระ")
            } else {
                //save
                let customer = [];
                this.form.user_id = this.user.id;
                if (this.form.customer && this.form.customer.length > 0) {
                    this.form.customer.forEach(data => {
                        customer.push(data.id);
                    });
                    this.form.customer_id = customer.toString();
                }
                //set data
                if (this.form.payoff_status_id == 2) {
                    this.form.payoff_status_id = 1;
                }
                let data = {
                    id: this.form.id,
                    date: moment(this.form.date).format("YYYY-MM-DD"),
                    payoff_status_id: this.form.payoff_status_id,
                    user_id: this.form.user_id,
                    customer_id: this.form.customer_id,
                    total: this.form.total,
                    amount: this.form.amount,
                    balance: this.form.balance,
                    fee_amount: this.form.fee_amount,
                    overpay: this.form.overpay,
                    arrears: this.form.arrears,
                    transactions: this.form.transactions,
                    details: [],
                    other_details: this.form.other_details
                };
                //console.log(data);
                // save to api
                this.isSubmit = true;
                this.showLoadingModal();
                this.msg = "กำลังบันทึกข้อมูล";
                this.status_loading = 1;
                this.$store.dispatch("InvoicePayoff/saveOtherDetails", {
                    id: data.id,
                    data: data
                }).then(res => {
                    this.printPDF(domain + `/payoff-other-pdf/${res.id}?user=${this.user.username}`)
                    this.isSubmit = false;
                    this.$store.dispatch("InvoicePayoff/getInvoicePayoffOtherList").then(() =>
                        this.$router.push({
                            name: "invoice-payoff-other"
                        })
                    )
                    // if(action == 'print'){
                    // this.$store.dispatch("InvoicePayoff/printInvoicePayoffOther",{
                    //     id : data.id,
                    //     user : this.user.name
                    // }).then(url=>{
                    //     if(url){
                    //         this.printPDF(url);
                    //     }
                    // })
                    // }else{
                    //     this.$router.push({
                    //         name : "invoice-payoff-other"
                    //     })
                    // }
                    this.hideLoadingModal();
                }).catch(() => {
                    this.showLoadingModal();
                    this.msg = "บันทึกข้อมูลไม่สำเร็จ";
                    this.status_loading = 3;
                });
            }
        },
        cancelPayoff() {
            this.$router.push("/invoice-payoff-other-form");
        },
        addCheque() {
            this.transactions.cheque = [
                ...this.transactions.cheque,
                {
                    transaction_type_id: 1,
                    cheque_bank_id: "",
                    ref_no: "",
                    date: "",
                    bank_name: "",
                    bank_branch: "",
                    amount: "",
                }
            ]
        },
        addTransfer() {
            this.transactions.transfer = [
                ...this.transactions.transfer,
                {
                    transaction_type_id: 2,
                    cheque_bank_id: "",
                    ref_no: "",
                    date: "",
                    bank_name: "",
                    bank_branch: "",
                    amount: "",
                }
            ]
        },
        removeCheque(index) {
            this.transactions.cheque = this.transactions.cheque.filter(
                (cheque, itemIndex) => index !== itemIndex
            )
        },
        removeTransfer(index) {
            this.transactions.transfer = this.transactions.transfer.filter(
                (cheque, itemIndex) => index !== itemIndex
            )
        },
        printPDF(url) {
            if (url) {
                window.open(url, '_blank');
                this.$router.push({
                    name: "invoice-payoff-other"
                })
            }
        }
    }
}
</script>

<style scoped>

</style>
